"use strict";

var mapL = require("../Lazy/mapL.js");

var curry = require("./curry.js");

var takeAll = require("./takeAll.js");

module.exports = curry(function map(f, iter) {
  return takeAll(mapL(f, iter));
});